module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "EXL"
  }, [_c('span', {
    staticClass: "SANS-B"
  }, [_vm._v("Huge black fly in my wife’s wine. She picks up fly & and says, “Spit it out!” Old Irish joke in my family works in French.")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("We turned the key, and got a call. We’d rented a house in California wine country for summer vacation and invited my mother to join us. She was eighty-four and had been declared cancer-free after a rough round of radiation treatments. We imagined how she’d ooh and aah through farmers’ markets, watch our daughters ride horses and muck stables, and sip her Rob Roy (scotch and sweet vermouth, with a maraschino cherry lowered like a depth charge into the center) looking over serene green vineyards.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She’d had good luck in recent years, and plenty of reverses. She had a happy third marriage (adding to what she called her “railroad train of a name,” Patricia Lyons Simon Newman Gelbin). She’d had cancer surgery; it worked. She loved her daughter-in-law and treasured her two grandchildren.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But my mother had also lost half a lung to cancer. She’d seen so many friends depart she said she didn’t want to answer the phone. “They say, ‘Hi, Pat, I’m Betsy’s niece, and I’m sorry to tell you…’” She had a constant cough no doctor could fathom, felt tired and winded, and often fell down. She’d slipped on ice coming back from a physical therapy session, lost six teeth, and got a great big purple eggplant of a bruised eye (I called her Rocky). She had dental surgery and eye stitching, and when all that had healed, she fell out of a kitchen chair while reading the newspaper (we told her: listen to the radio). She got depressed at the idea she would never feel well again.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("And then little nits of cancer—on the x-ray, they looked like dim, distant stars—began to glimmer in her one good lung.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Guess I’ll do whatever I have to do,” she said, which were radiation sessions where she was trussed up like a Christmas goose and zapped for half an hour with a ray strong enough to peel paint—or kill cancer.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You always come roaring back,” we told her. “Like a lioness.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’m more likely to have a small little bark, like a poodle,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You’ll live to be a hundred. People do nowadays.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Not like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("So we’d reached that point where my wife and I began to say, “Let’s see Grand-m"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("è")]), _vm._v("re”—what our daughters called her; Caroline, my wife, is French—“as much as possible.” But all of my mother’s trials only made us think of her as strong. She had survived bruises, spills, cancer, grief, and sorrows, and just kept going.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("She was getting ready to join us in California when she noticed she had lost about twenty pounds—without trying—and so she brought her blue jeans to a seamstress and her body to the hospital for a blood test. She’d read an article that said tuberculosis was on the rise; weight loss and a constant cough were among the symptoms. She didn’t want to put our daughters at risk.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The blood test didn’t reveal tuberculosis. But the doctors didn’t like what they saw. We had turned the key to the house when Matthew, my mother’s husband, called.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Your mom is in the hospital.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What’s wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Nothing. They just didn’t like what they saw.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“What did they see?”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“They don’t know. But she can’t fly out tomorrow.…”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("By the time I spoke to my mother a few hours later, she seemed more distressed that the airline would exact a fee to change her flight than about her condition.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("(I see now that this may have been an act.)")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“They get you every damn which way these days, don’t they?” she asked me.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Still, she was eighty-four.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Still, maybe I should…”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“No.” Her voice was firm. “Your daughters deserve a vacation with their father. Besides, I’ll be out in just a few days.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("A few more days passed. I kept my mother informed about all the daughters, dogs, and horses, and how there were radishes as big as baseballs and strawberries as red as lipstick in the fields just outside our windows.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("One morning my mother called before dawn. We could still hear coyotes whine (they make you flinch, like mewling children) in the hills above the vineyards.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Darling, I can’t talk now,” she said. “I’m surrounded by handsome men. They’re taking me in for surgery—well, you know, they don’t like to call it surgery, that gets people worried, so they call it a "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("surgical procedure")]), _vm._v("—but they’re putting me to sleep to put a camera into my lung and take a look at something.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Smile” is all I could think to tell her.")]), _vm._v(" "), _c('p', {
    staticClass: "SB-STD"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "SB2"
  }, [_vm._v("My mother called again a few hours later to say doctors had detected a mysterious dark something in her one good lung. It could be a fungus, it could be scarring—or it could be cancer.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I think I better…”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Don’t,")]), _vm._v("” my mother said in a scolding tone she knew made a difference with me. “Matthew is with me. I’ll be fine. Look, darling, this isn’t the end,” she said. “This thing in my lung—that may be the end of me. But even if it’s cancer again, we’ll have some time.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But during all this time, we heard just about nothing from any doctor. We were told that a pulmonologist who had once diagnosed her with cancer was overseeing her care. She stopped in to see my mother once, and never returned my (increasingly truculent) phone messages. I’d get an occasional call back from one or another young resident who had at least seen my mother. But whole days went by when my mother said no doctor had looked in on her. The nurses were attentive and considerate, but she felt that doctors just didn’t want to bother.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I left a message for the pulmonologist: “When our cat was spayed, the vet called twice a day. Is one call a week too much to ask for a patient who’s under intensive care?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("(That message didn’t work either.)")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("So I told my mother I was going to get on a plane. This time she didn’t argue.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I just want to get this cleared up, whatever it is, good or bad, and go home.” Then she added, “There’s a show at the Museum of Contemporary Art”—it was across the street from the hospital—“that we could see, anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My wife was driving me to the San Francisco airport when one of the young residents phoned.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Your mother doesn’t want any more care,” she announced.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“But I just spoke to her. She sounded strong. She’s tired of all the uncertainty and wants to go home, of course,” I began, and the resident jumped in.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“She said she doesn’t want anything else done for her.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“That’s not possible. I know she doesn’t want any extreme measures, but aren’t we a ways from that?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My wife bore down on twisting roads. Our hearts thumped in our ears.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“She says she doesn’t want anything more.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I have her power of attorney,” I told her. “I’m empowered to make medical decisions for her.” But the resident persisted.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I talked to a senior physician. He says we have to follow what your mother said. She wants no more care.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I erupted.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I think you heard my mother say she’s tired and wants to go home. You just heard certain code words and think she’s saying she wants no more care. Can’t you hear that she’s fighting to find out what’s wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I was mad, loud, and no doubt insufferable.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“If you’re going to be a good doctor someday,” I shouted, “you have to listen with your heart! She wants help. Help her!”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I phoned my mother and struggled to sound unruffled.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“What time do you land?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“About ten.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“If you go straight to Rick’s,” she said of a friend’s restaurant, “I’ll bet you can still get a margarita.”")]), _vm._v(" "), _c('p', {
    staticClass: "TXS"
  }, [_vm._v("She didn’t sound like a woman who wanted out. But I boarded the plane in San Francisco wondering—based on the word of a young resident with tin ears—if those would be my mother’s last words to me.")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_c('span', {
    staticClass: "SANS-B"
  }, [_vm._v("New family motto: no tamale left behind.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba71cd12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 78
// module chunks = 0